import { render, staticRenderFns } from "./AncestrylineDataTable.vue?vue&type=template&id=8fd7ffe2&scoped=true"
import script from "./AncestrylineDataTable.vue?vue&type=script&lang=js"
export * from "./AncestrylineDataTable.vue?vue&type=script&lang=js"
import style0 from "./AncestrylineDataTable.vue?vue&type=style&index=0&id=8fd7ffe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd7ffe2",
  null
  
)

export default component.exports